module.exports = __webpack_public_path__ + "public/img/tower10.ddb95444.png";